import { useRef } from 'react';

export function useScaleHover<T extends HTMLElement = HTMLDivElement>() {
  const ref = useRef<T>(null);
  const scaleUp = () => {
    if (!ref.current) return;
    let scale = 1;
    const step = 0.01;
    const max = 1.1;
    const interval = setInterval(() => {
      scale = Math.min(max, scale + step);
      if (ref.current) ref.current.style.transform = `scale(${scale})`;
      if (scale >= max) clearInterval(interval);
    }, 16);
    (ref.current as any).dataset.scaleInterval = String(interval);
  };
  const scaleDown = () => {
    if (!ref.current) return;
    let scale = 1.1;
    const step = 0.01;
    const min = 1;
    const interval = setInterval(() => {
      scale = Math.max(min, scale - step);
      if (ref.current) ref.current.style.transform = `scale(${scale})`;
      if (scale <= min) clearInterval(interval);
    }, 16);
    (ref.current as any).dataset.scaleInterval = String(interval);
  };
  return { ref, scaleUp, scaleDown };
} 